export default {
    install(app) {
        // Register global components here
    }
}
